import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(content)/about/components/about-page.tsx");
